import * as React from "react";

import { Help } from "../../../../../parts/help";
import { CpRecognitionRateValueRow } from "./cp-recognition-rate-value-row";
import { ChangeRateValue } from "../../../../../../../../server/models/cp2";
import { CurrentProductCorrectionValue } from "../../../../../../../../server/types/request/report/simulation";

type Props = {
	correctionValue: CurrentProductCorrectionValue;
	hasEditRole: boolean;
	initRecognition: number;
	maxRecognition: number;
	onChange: <K extends keyof ChangeRateValue>(name: K, value: ChangeRateValue[K]) => void;
};

// CP実績補整タブ
// 現行品/類似品の商品認知率補整
// 補整変数テーブル
// 商品認知率のみを残す

export const CpCorrectionValueSettingTable = React.memo((props: Props) => {
	const { correctionValue, hasEditRole, initRecognition, maxRecognition, onChange } = props;

	return (
		<table className="result-table simulation">
			<thead>
				<tr>
					<th className="subtitle">
						{/* ラベルの提示無し */}
						<></>
					</th>

					<th>
						初期値
						<Help explain="初期値は、表示されていない小数点2位以下の数値も計算には参照しています。" id="initial" />
					</th>

					<th>
						修正値
						<Help
							explain="初期値から変更しない場合は、手入力ではなく、必ず「初期値から変更しない」ボタンを押してください。"
							id="correctionValue"
						/>
					</th>

					<th>修正率（％）</th>

					<th>修正根拠（初期値から変更した場合、入力必須）</th>
				</tr>
			</thead>

			<tbody>
				{/* 商品認知率(%) */}
				<CpRecognitionRateValueRow
					hasEditRole={hasEditRole}
					init={initRecognition}
					maxRecognition={maxRecognition}
					onChangeReason={(v) => {
						onChange("reason", v);
					}}
					onChangeValue={(v) => {
						onChange("value", v);
					}}
					reason={correctionValue.recognitionRate?.reason}
					value={correctionValue.recognitionRate?.value}
				/>
			</tbody>
		</table>
	);
});
